import React from "react";
import { Typography } from "@mui/material";
import FooterButtons from "./FooterButtons";
import SimplePaper from "../components/SimplePaper";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faYoutube, faInstagram } from "@fortawesome/free-brands-svg-icons";

const About = () => {
  const title = "AstroData"; // it can be OPC,

  const body = (
    <>
      <Typography variant="body1" paragraph>
        Welcome to AstroData, the ultimate destination for astrology enthusiasts
        seeking a blend of scientific accuracy and traditional wisdom. Our
        mission is to transform the way you perceive astrology by offering an
        interactive, logical, and scientifically-grounded approach to
        understanding planetary influences and their impact on your life.
      </Typography>

      <Typography variant="h4" gutterBottom>
        What We Offer
      </Typography>

      <Typography variant="h5" gutterBottom>
        Interactive (AI) Kundali Chart Calculator
      </Typography>
      <Typography variant="body1" paragraph>
        Experience the world's most powerful interactive Kundali chart
        calculator. As you hover over planets, you can visually see and
        understand their nature and influence, making predictions as easily as
        drinking water. Our advanced algorithms provide precise, mathematical
        insights that bring a new level of accuracy to your astrological
        readings.
      </Typography>

      <Typography variant="h5" gutterBottom>
        Comprehensive Resources
      </Typography>
      <Typography variant="body1" paragraph>
        Dive into a wealth of knowledge with our extensive database of blogs,
        research documents, and resources. Explore articles written by our
        founder, study the astrological charts of famous personalities, and
        access valuable links to other reputable astrology sites and books. We
        aim to be your one-stop resource for all things astrology.
      </Typography>

      <Typography variant="h5" gutterBottom>
        AI-Powered Predictions
      </Typography>
      <Typography variant="body1" paragraph>
        AstroData is pioneering the integration of AI in astrology. Our
        cutting-edge technology delivers the most accurate predictions by
        combining traditional astrological principles with modern scientific
        methods. We focus on certainty and probability to give you reliable and
        insightful forecasts.
      </Typography>

      <Typography variant="h5" gutterBottom>
        Community and Learning
      </Typography>
      <Typography variant="body1" paragraph>
        Join our community of astrology enthusiasts and learners. Save your
        charts, track your progress, and access all our features completely free
        of charge. We believe in making astrology accessible to everyone,
        fostering a supportive environment where you can grow your knowledge and
        skills.
      </Typography>

      <Typography variant="h5" gutterBottom>
        Personal Consultations and Reports
      </Typography>
      <Typography variant="body1" paragraph>
        For those seeking deeper insights, we offer personalized reports at the
        most affordable prices. Additionally, you can buy a personal
        consultation to receive expert advice tailored to your unique chart. Our
        founder is dedicated to providing detailed readings and spending quality
        time discussing your astrological profile.
      </Typography>

      <Typography variant="h5" gutterBottom>
        Support Us
      </Typography>
      <Typography variant="body1" paragraph>
        Your support helps us keep AstroData free and accessible. Consider
        making a donation, and as a token of our gratitude, you will receive a
        free reading of your chart and a one-hour personal discussion. Your
        contributions enable us to continue offering valuable services and
        developing innovative tools for the astrology community.
      </Typography>

      <Typography variant="body1" paragraph>
        Thank you for visiting AstroData. Explore, learn, and uncover the
        wonders of astrology with a scientific and logical lens. Together, let's
        elevate astrology to new heights of understanding and precision.
      </Typography>

      <Typography variant="body1" paragraph>
        Feel free to reach out if you have any questions or need assistance.
        We're here to help you on your astrological journey!
      </Typography>

      <Typography variant="body1" paragraph>
        <strong>Follow Us:</strong>
        <FontAwesomeIcon
          style={{ fontSize: "3vh", marginLeft: "3vh" }}
          icon={faYoutube}
        />
        <FontAwesomeIcon
          style={{ fontSize: "3vh", marginLeft: "2vh" }}
          icon={faInstagram}
        />
      </Typography>
    </>
  );

  return (
    <>
      <SimplePaper title={title} body={body} />
      <FooterButtons />
    </>
  );
};

export default About;
